import React from "react";
import styles from "./next-arrow.module.css";
import NextArrowSvg from "./NextArrowSvg";

const NextArrow = ({ handler }) => {
  return (
    <div className={styles.buttonContainer}>
      <button onClick={handler} className={styles.nextButton}>
        <NextArrowSvg />
      </button>
    </div>
  );
};

export default NextArrow;
